import { useSelector } from 'react-redux';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { usePhoneNumber } from './use-phone-number';

export const useImportContactsPermission = () => {
  const { isSmsSupported, hasNumber } = usePhoneNumber();
  const hasSmsContactUploadFeature = useSelector(
    combinedFeatureFlagsSelector,
  ).sms_contact_uploads;

  const fbPage = useSelector(activeFacebookPageSelector);
  const isSmsActivated = isSmsSupported && hasNumber && fbPage?.smsActivated;
  const isEmailActivated = !!fbPage?.emailActivated;

  const canMapPhoneNumber = hasSmsContactUploadFeature;

  return {
    isAllowed: isSmsActivated || isEmailActivated,
    isSmsActivated,
    isEmailActivated,
    canMapPhoneNumber,
  };
};
